import { render } from "./private-collection.vue?vue&type=template&id=55c92ef4"
import script from "./private-collection.vue?vue&type=script&lang=js"
export * from "./private-collection.vue?vue&type=script&lang=js"

import "./private-collection.vue?vue&type=style&index=0&id=55c92ef4&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__